import { Card, CardBody } from "reactstrap";
import { LucideIcon } from "lucide-react";

interface StatCardProps {
    title: string;
    value: number;
    icon: LucideIcon;
    color: string;
}

function StatCard({
    title,
    value,
    icon: Icon,
    color
}: StatCardProps) {
    return (
        <Card className="shadow-sm border-0 rounded-4 h-100">
            <CardBody className="text-center">
                <div
                    className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                    style={{
                        width: 60,
                        height: 60,
                        background: color,
                        color: "#fff"
                    }}
                >
                    <Icon size={28} />
                </div>

                <h6 className="text-muted">{title}</h6>

                <h2 className="fw-bold">{value}</h2>
            </CardBody>
        </Card>
    );
}

export default StatCard;